import styles from "./StartupAccount.module.scss";
import { Header } from "../../components/common/Header";
import { Info } from "../../components/Info";
import { UserInitials } from "../../components/common/UserInitials";
import { HelpStartup } from "../../components/HelpStartup";
import { useState } from "react";
import { Table } from "../../components/Table";
import { History } from "../../components/History";

import { StartupTeam } from "../../components/StartupTeam";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';

//mock
const user = "Sarah Lee";

//mock
const shortInfoBySatartup = [
  { label: "VERSCHILLENDE BEGELEIDERS", value: "62" },
  { label: "STARTUPS SAMEN", value: "521" },
  { label: "ONZE KLANTTEVREDENHEID", value: "8.3" },
];

const table1 = {
  theadData: ["NAAM", "ORGANISATIE", "FUNCTIE"],
  tbodyData: [
    {
      id: "1",
      items: ["Floris", "X", "Co-Founder"],
    },
  ],
};

const table2 = {
  theadData: ["SECTOR", "TELEFOONNUMMER", "MAILADRES"],
  tbodyData: [
    {
      id: "1",
      items: ["Tech", "06-0101010", "Floris.M@mail.nl"],
    },
  ],
};

const table3 = {
  theadData: ["NAAM", "ORGANISATIE", "STAD"],
  tbodyData: [
    {
      id: "1",
      items: ["Pepijn Herman ", "Hypetrain", "Tilburg"],
    },
  ],
};

const table4 = {
  theadData: ["SECTOR", "TELEFOONNUMMER", "MAILADRES"],
  tbodyData: [
    {
      id: "1",
      items: ["Tech", "06-0101010", "Pepijn.h@mail.nl"],
    },
  ],
};

const history = [
  "Ivenstor Readiness Program | Editie 16 | 20-06-2022 / 25-08-2022 | Lopend",
  "Ivenstor Readiness Program | Editie 15 | 20-06-2022 / 25-08-2021 | Afgerond",
  "Ivenstor Readiness Program | Editie 14 | 20-06-2022 / 25-08-2020 | Afgerond",
  "Ivenstor Readiness Program | Editie 13 | 20-06-2022 / 25-08-2019 | Afgerond",
  "Ivenstor Readiness Program | Editie 12 | 20-06-2022 / 25-08-2018 | Afgerond",
];

const team = [
  {
    id: "1",
    description:
      "Rincke Helling | Product Developer | rincke@gritd.nl | 06-41017541",
  },
  {
    id: "2",
    description:
      "Floris Meulensteen | Product Developer | floris@gritd.nl | 06-51794420",
  },
  {
    id: "3",
    description: "Stephan Botz | Co-Founder | stephan@gritd.nl | 06-31416681",
  },
  {
    id: "4",
    description: "Persoon x Editie 13 | xxx@mail.nl | 06-21876320",
  },
  {
    id: "5",
    description: "Persoon x | Editie 12 | xxx@mail.nl | 06-31758920",
  },
];

//mock

export const StartupAccount = () => {
  const [isChange, setIsChange] = useState(false);

  const [teamMembers, setTeamMembers] = useState(team);

  const deleteTeamMember = (id: string) => {
    setTeamMembers([...teamMembers].filter((item) => item.id !== id));
  };

  return (
    <div className={styles.wrapper}>
      <GreetingsHeader title="Hallo <me.name>, welkom bij" subtitle="Accountinstellingen" />
      <section className={styles.infoContainer}>
        <Info
          title="PERSOONLIJK ACCOUNT"
          description="Jouw startup is aangemeld door een van onze begeleiders. Via dit overzicht kan jij eigen gegevens inzien en wijzigigen. Voeg ook je teamleden toe en bekijk welke programma’s je hebt afgerond."
          element={<UserInitials userName={user} />}
        />
      </section>
      <section className={styles.helpStartup}>
        <HelpStartup options={shortInfoBySatartup} />
      </section>
      <section className={styles.personalData}>
        <h3 className={styles.header}>PERSOONLIJKE GEGEVENS</h3>
        <div className={styles.tableContainer}>
          {/*<Table table={table1} readOnly isChange={isChange} />*/}
        </div>
        <div className={styles.tableContainer2}>
          {/*<Table table={table2} readOnly isChange={isChange} />*/}
        </div>
        {!isChange ? (
          <button
            type="button"
            className={styles.button}
            onClick={() => setIsChange(!isChange)}
          >
            Gegevens wijzigen
          </button>
        ) : (
          <div className={styles.buttons}>
            <button type="button" className={styles.button}>
              Opslaan
            </button>
            <button
              type="button"
              className={styles.button}
              onClick={() => setIsChange(!isChange)}
            >
              Annuleren
            </button>
          </div>
        )}
      </section>
      <section className={styles.team}>
        <StartupTeam team={teamMembers} deleteTeamMember={deleteTeamMember} />
      </section>
      <section className={styles.guide}>
        <h3 className={styles.header}>GEGEVENS - BEGELEIDER</h3>
        <div className={styles.tableContainer}>
          {/*<Table table={table3} readOnly isChange={isChange} />*/}
        </div>
        <div className={styles.tableContainer2}>
          {/*<Table table={table4} readOnly isChange={isChange} />*/}
        </div>
      </section>
      <section className={styles.history}>
        <History options={history} />
      </section>
    </div>
  );
};
